import { useProductsStore } from "@/store/products";
import { useMagasinStore } from "@/store/magasin";
import { pushProps, usePush } from "@/components/pages/mixins/push-mixin";
import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";
import pageMarronnierCodes from "@/utils/page-marronnier-codes";

export const pageMarronniersProps = () => ({
  pageType: {
    type: String,
    default: null
  },
  ...pushProps()
})

export const usePageMarronniers = (props) => {
  const { getPushData, getPushTitle } = usePush(props.pushZones);
  const productsStore = useProductsStore();
  const magasinStore = useMagasinStore();

  const limitMaxRayon = 10;

  const {
    title,
    description,
    breadcrumbs,
    childrenCategories,
    attributes
  } = storeToRefs(productsStore);

  const { isNational } = storeToRefs(magasinStore);

  const breadcrumb = computed(() => {
    return breadcrumbs.value.map((item) => (
      { text: item.title, route: item.slug }
    ))
  })
  const pushDataBanniereMea = computed(() => {
    return getPushData(pagesNiv3et4Codes.BANNIERE_MEA);
  })
  const marronniersMerchProduit = computed(() => {
    return getPushData(pageMarronnierCodes.MARRONNIER_PRODUITS)
  })

  return {
    pageMarronnierCodes,
    limitMaxRayon,
    title,
    description,
    breadcrumbs,
    childrenCategories,
    attributes,
    isNational,
    breadcrumb,
    pushDataBanniereMea,
    marronniersMerchProduit,
    getPushData,
    getPushTitle
  }

}